<template>
  <div
    id="folder-permissions"
    class="page"
  >
    <content-spinner :show="loading" />
    <template v-if="!loading">
      <div
        v-if="permissionData.data && isSinglePage"
        class="page-toolbar bg-white shadow-sm p-3"
      >
        <h4 class="m-0">
          Manage permissions for {{ getName() }}
        </h4>
      </div>
      <div
        id="pageContent"
        class="page-content p-4"
      >
        <div class="d-flex flex-column card-page-content">
          <div
            class="row"
            style="height: 100%"
          >
            <div class="col">
              <b-card
                :class="[{'position-absolute': isSinglePage}, 'permission-card']"
                header="Users"
                no-body
              >
                <template #header>
                  <div class="d-flex justify-content-between align-items-center">
                    <h4 class="mb-0">
                      Users and Groups
                    </h4>
                    <user-list-popover
                      ref="user-popover"
                      :selected-users="assignedUserPermissions.map(p => p.user_uuid)"
                      :is-single-page="isSinglePage"
                      :component-id="componentId"
                      @userSelect="userSelect"
                      @userRemove="userRemove"
                    />
                  </div>
                </template>
                <content-spinner
                  :fullscreen="true"
                  :show="usersLoading"
                />
                <b-card-body style="overflow: auto;">
                  <no-content
                    :show="!assignedUserPermissions.length"
                    text="No Permissions defined"
                  />
                  <b-list-group v-if="assignedUserPermissions.length">
                    <b-list-group-item
                      v-for="p in assignedUserPermissions"
                      class="d-flex align-items-center"
                    >
                      <b-avatar
                        variant="primary"
                        :text="getAvatarText(p.user)"
                        class="mr-3"
                      />
                      <span class="mr-auto">{{ p.user.displayName }}</span>
                      <b-form-select
                        v-model="p.access_level"
                        class="user-select-permission"
                        style="width: 6rem"
                        :options="permissionTypes"
                        @change="onUserPermissionChange(p.user)"
                      />
                      <b-button
                        variant="link"
                        pill
                        class="btn-delete text-danger delete-user"
                        @click="onDeleteUserPermission(p)"
                      >
                        <font-awesome-icon :icon="'trash'" />
                      </b-button>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-card>
            </div>
            <!--            <div class="col">-->
            <!--              <b-card class="permission-card" header="Groups" no-body>-->
            <!--                <template v-slot:header>-->
            <!--                  <div class="d-flex justify-content-between align-items-center">-->
            <!--                    <h4 class="mb-0">Groups</h4>-->
            <!--                    <group-list-popover :selected-groups="assignedGroupPermissions.map(p => p.group_uuid)"-->
            <!--                                        :isSinglePage="isSinglePage"-->
            <!--                                        :componentId="componentId"-->
            <!--                                        :groups="groups.data" ref="group-popover" @groupSelect="groupSelect"-->
            <!--                                        @groupRemove="groupRemove">-->
            <!--                    </group-list-popover>-->
            <!--                  </div>-->
            <!--                </template>-->
            <!--                <content-spinner :fullscreen="true" :show="groupsLoading"/>-->
            <!--                <b-card-body style="overflow: auto;">-->
            <!--                  <no-content :show="!assignedGroupPermissions.length" text="No Permissions defined for groups"/>-->
            <!--                  <b-list-group v-if="assignedGroupPermissions.length">-->
            <!--                    <b-list-group-item v-for="p in assignedGroupPermissions" class="d-flex align-items-center">-->
            <!--                      <b-avatar variant="primary" :text="p.group.DisplayName[0].toUpperCase()" class="mr-3"/>-->
            <!--                      <span class="mr-auto">{{ p.group.DisplayName }}</span>-->
            <!--                      <b-form-select class="group-select-permission" style="width: 6rem" v-model="p.access_level" :options="permissionTypes"-->
            <!--                                     @change="onGroupPermissionChange(p.group)">-->
            <!--                      </b-form-select>-->
            <!--                      <b-button @click="onDeleteGroupPermission(p)" variant="link" pill class="btn-delete text-danger delete-group">-->
            <!--                        <font-awesome-icon :icon="'trash'"/>-->
            <!--                      </b-button>-->
            <!--                    </b-list-group-item>-->
            <!--                  </b-list-group>-->
            <!--                </b-card-body>-->
            <!--              </b-card>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import UserListPopover from '../../components/UserListPopover';
import GroupListPopover from '../../components/GroupListPopover';
import NoContent from '../../../../core/components/NoContent';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import {axiosClient} from '../../../../core/services/http.service';


const {mapActions, mapState} = createNamespacedHelpers('dataManagement');
const {mapActions: mapActionsUser, mapState: mapStateUsers} = createNamespacedHelpers('user');
export default {
  name: 'Permissions',
  components: {UserListPopover, GroupListPopover, NoContent, ContentSpinner},
  props: {
    modalData: {
      type: Object,
      default: () => {
        return {
          itemId: null,
          type: null,
          data: null,
          name: null,
        };
      },
    },
    isSinglePage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      permissions: [],
      usersLoading: false,
      groupsLoading: false,
      permissionData: {},
      permissionList: [],
      loading: false,
      componentId: null,
    };
  },
  watch: {
    ['permissionData.data']() {
      if (this.permissionData.data.permissions) {
        this.permissions = [...this.permissionData.data.permissions.map(p => ({...p}))];
      }
    },
  },
  computed: {
    ...mapState(['moduleData', 'folderData', 'tableData', 'fieldData', 'permissionObjectData']),
    ...mapState({
      permissionItemTypes: state => state.permissionItemTypes,
    }),
    ...mapStateUsers(['users', 'groups']),
    assignedUserPermissions() {
      return this.permissions.filter(p => !!p.user);
    },
    assignedGroupPermissions() {
      return this.permissions.filter(p => !!p.group);
    },
    permissionTypes() {
      return [
        {value: 'deny', text: 'Deny'},
        {value: 'read', text: 'Read'},
        {value: 'write', text: 'Write'},
        {value: 'delete', text: 'Delete'},
        {value: 'post', text: 'Post'},
        {value: 'unpost', text: 'Unpost'},
        {value: 'edit', text: 'Edit'},
        {value: 'admin', text: 'Admin'},
      ];
    },
  },
  methods: {
    ...mapActions([
      'getModuleData', 'assignUsersToModule', 'assignGroupsToModule',
      'getFolderData', 'assignUsersToFolder', 'assignGroupsToFolder',
      'getTableData', 'assignUsersToTable', 'assignGroupsToTable',
      'getFieldData', 'assignUsersToField', 'assignGroupsToField',
      'getPermissionsByObjectId', 'updatePermission', 'createPermission', 'deletePermission',
    ]),
    ...mapActionsUser(['getUsersAndGroups']),
    async onDeleteUserPermission(perm) {
      if (perm.permissionGuid) {
        this.closeUserPopover();
        const success = await this.$confirm('Deleting Permission...', `You are deleting permission for user ${perm.user.displayName}. Are you sure you want to continue?`);
        if (success) {
          this.usersLoading = true;
          const {success, body} = await this.deletePermission(perm.permissionGuid);
          this.usersLoading = false;
          if (success) {
            this.$toasted.success(`Permission for "${perm.user.displayName}" deleted`, {
              duration: TOASTER_DURATION,
            });
            this.permissions = this.permissions.filter(p => perm.user_uuid !== p.user_uuid);
          } else {
            this.$toasted.error(body.ErrorMessage, {
              duration: TOASTER_DURATION,
            });
          }
        }
      } else {
        this.permissions = this.permissions.filter(p => perm.user_uuid !== p.user_uuid);
      }
    },
    async onDeleteGroupPermission(perm) {
      if (perm.permissionGuid) {
        this.closeGroupPopover();
        const success = await this.$confirm('Deleting Permission...', `You are deleting permission for group ${perm.group.DisplayName}. Are you sure you want to continue?`);
        if (success) {
          this.groupsLoading = true;
          const {success, body} = await this.deletePermission(perm.permissionGuid);
          this.groupsLoading = false;
          if (success) {
            this.$toasted.success(`Permission for user ${perm.group.DisplayName} deleted`, {
              duration: TOASTER_DURATION,
            });
            this.permissions = this.permissions.filter(p => perm.group_uuid !== p.group_uuid);
          } else {
            this.$toasted.error(body.ErrorMessage, {
              duration: TOASTER_DURATION,
            });
          }
        }
      } else {
        this.permissions = this.permissions.filter(p => perm.group_uuid !== p.group_uuid);
      }
    },
    closeUserPopover() {
      this.$refs['user-popover'].$refs.popover.$emit('close');
    },
    closeGroupPopover() {
      this.$refs['group-popover'].$refs.popover.$emit('close');
    },
    getAvatarText(user) {
      return user.displayName.split(' ').map(el => el[0] ? el[0].toUpperCase() : '').join('');
    },
    getName() {
      if (this.type === this.permissionItemTypes.module) {
        return `Module "${this.modalData.name || this.permissionData.data.moduleName}"`;
      } else if (this.type === this.permissionItemTypes.folder) {
        return `Folder "${this.permissionData.data.folderName}"`;
      } else if (this.type === this.permissionItemTypes.table) {
        return `Table "${this.permissionData.data.displayName}"`;
      } else if (this.type === this.permissionItemTypes.field) {
        return this.getFieldName();
      }
    },
    getFieldName() {
      if (this.modalData.data && this.modalData.data.isNew) {
        return `Field "${this.modalData.data.displayName}"`;
      }
      return `Field "${this.permissionData.data.displayName}"`;
    },
    // async getAssignUsersResponse(permissions) {
    //   if (this.type === this.permissionItemTypes.module) {
    //     return await this.assignUsersToModule({moduleUuid: this.itemId, permissions});
    //   } else if (this.type === this.permissionItemTypes.folder) {
    //     return await this.assignUsersToFolder({folderUuid: this.itemId, permissions});
    //   } else if (this.type === this.permissionItemTypes.table) {
    //     return await this.assignUsersToTable({tableName: this.itemId, permissions});
    //   } else if (this.type === this.permissionItemTypes.field) {
    //     return await this.assignUsersToField({
    //       fieldUuid: this.itemId,
    //       permissions,
    //       isNew: this.modalData.data && this.modalData.data.isNew
    //     });
    //   }
    // },
    async submitUserPermissions(user) {
      this.usersLoading = true;
      const item = {...this.permissions.find(perm => perm.user_uuid === user.id)};

      const params = {
        userGuid: item.user_uuid,
        objectGuid: this.itemId,
        permissionLevel: item.access_level,
      };

      let response;
      if (item.permissionGuid) {
        params.permissionGuid = item.permissionGuid;
        response = await this.updatePermission(params);
      } else {
        response = await this.createPermission(params);
      }

      if (response.success) {
        this.$toasted.success(`Permission for "${item.user.displayName}" ${item.permissionGuid ? 'updated' : 'created'}`, {
          duration: TOASTER_DURATION,
        });
      } else {
        this.$toasted.error(response.body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
      await this.getData();
      this.usersLoading = false;
    },
    // async getAssignGroupsResponse(permissions) {
    //   if (this.type === this.permissionItemTypes.module) {
    //     return await this.assignGroupsToModule({moduleUuid: this.itemId, permissions});
    //   } else if (this.type === this.permissionItemTypes.folder) {
    //     return await this.assignGroupsToFolder({folderUuid: this.itemId, permissions});
    //   } else if (this.type === this.permissionItemTypes.table) {
    //     return await this.assignGroupsToTable({tableName: this.itemId, permissions});
    //   } else if (this.type === this.permissionItemTypes.field) {
    //     return await this.assignGroupsToField({
    //       fieldUuid: this.itemId,
    //       permissions,
    //       isNew: this.modalData.data && this.modalData.data.isNew
    //     });
    //   }
    // },
    async submitGroupPermissions(group) {
      this.groupsLoading = true;
      const item = {...this.permissions.find(perm => perm.group_uuid === group.Id)};

      const params = {
        userGuid: item.group_uuid,
        objectGuid: this.itemId,
        permissionLevel: item.access_level,
      };

      let response;
      if (item.permissionGuid) {
        params.permissionGuid = item.permissionGuid;
        response = await this.updatePermission(params);
      } else {
        response = await this.createPermission(params);
      }

      if (response.success) {
        this.$toasted.success(`Permission for user ${item.group.DisplayName} ${item.permissionGuid ? 'updated' : 'created'}`, {
          duration: TOASTER_DURATION,
        });
      } else {
        this.$toasted.error(response.body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
      await this.getData();
      this.groupsLoading = false;
    },
    async userSelect(user) {
      this.permissions = [...this.permissions, {access_level: 'read', user_uuid: user.id, user}];
      await this.submitUserPermissions(user);
    },
    async userRemove(user) {
      const userPermission = this.permissionList.find(p => p.userGuid === user.id);
      if (userPermission) {
        const perm = {
          user: user,
          access_level: userPermission.permissionLevel,
          user_uuid: user.id,
          permissionGuid: userPermission.permissionGuid,
        };
        await this.onDeleteUserPermission(perm);
      } else {
        this.permissions = this.permissions.filter(p => p.user_uuid !== user.id);
      }
    },
    async groupSelect(group) {
      this.permissions = [...this.permissions, {access_level: 'read', group_uuid: group.Id, group}];
      await this.submitGroupPermissions(group);
    },
    async groupRemove(group) {
      const groupPermission = this.permissionList.find(p => p.userGuid === group.Id);
      if (groupPermission) {
        const perm = {
          group: group,
          access_level: groupPermission.permissionLevel,
          group_uuid: group.Id,
          permissionGuid: groupPermission.permissionGuid,
        };
        await this.onDeleteGroupPermission(perm);
      } else {
        this.permissions = this.permissions.filter(p => p.group_uuid !== group.Id);
      }
    },
    async onUserPermissionChange(user) {
      await this.submitUserPermissions(user);
    },
    // async onGroupPermissionChange(group) {
    //   await this.submitGroupPermissions(group)
    // },
    async getData() {
      if (this.type === this.permissionItemTypes.module) {
        await this.getModuleData(this.itemId);
        this.permissionData = this.moduleData;
        await this.getPermissionsByObjectId(this.itemId);
        this.permissionList = [...this.permissionObjectData];
      } else if (this.type === this.permissionItemTypes.folder) {
        await this.getFolderData(this.itemId);
        this.permissionData = this.folderData;
        await this.getPermissionsByObjectId(this.itemId);
        this.permissionList = [...this.permissionObjectData];
      } else if (this.type === this.permissionItemTypes.table) {
        await this.getTableData(this.itemId);
        this.permissionData = this.tableData;
        await this.getPermissionsByObjectId(this.itemId);
        this.permissionList = [...this.permissionObjectData];
      } else if (this.type === this.permissionItemTypes.field) {
        if (this.modalData.data && this.modalData.data.isNew) {
          this.permissionData = {
            data: this.modalData.data,
            loading: false,
          };
        } else {
          await this.getFieldData(this.itemId);
          this.permissionData = this.fieldData;
        }
        await this.getPermissionsByObjectId(this.itemId);
        this.permissionList = [...this.permissionObjectData];
      }
      if (this.permissionList.length) {
        const ids = this.permissionList.map(p => p.userGuid);

        const {success, body: users} = await axiosClient.post('api/aad/users', ids);
        const res = users.map(u => ({
          id: u.userGuid,
          displayName: u.displayName,
          mail: u.mail,
        }));
        if (!success) {
          return;
        }
        // let users = this.users.data.filter(user => ids.includes(user.id))
        // let groups = this.groups.data.filter(group => ids.includes(group.Id))
        this.permissions = res.map(user => {
          const perm = this.permissionList.find(p => p.userGuid === user.id);
          return {
            user: user,
            access_level: perm.permissionLevel,
            user_uuid: user.id,
            permissionGuid: perm.permissionGuid,
          };
        });
        // groups.forEach(group => {
        //   let perm = this.permissionList.find(p => p.userGuid === group.Id)
        //   this.permissions = [
        //     ...this.permissions,
        //     {
        //       group: group,
        //       access_level: perm.permissionLevel,
        //       group_uuid: group.Id,
        //       permissionGuid: perm.permissionGuid
        //     }
        //   ]
        // })
      }
    },
    setInitialData() {
      this.itemId = this.modalData.itemId || this.$route.params.itemId;
      this.type = this.modalData.type || this.$route.params.type;
      this.componentId = this.itemId.trim().replace(/\s/g, '-').toLowerCase();
    },
  },
  async mounted() {
    this.loading = true;
    await this.setInitialData();
    await this.getUsersAndGroups();
    await this.getData();
    this.loading = false;
  },
};
</script>

<style lang="scss">
.card-page-content {
  overflow: hidden;
  height: 100%;
}

.permission-card {
  max-height: 100%;
  height: 100%;
  width: 95%;
}

#users-popover, #groups-popover {
  font-size: .75rem;
  max-height: 545px;
  overflow: auto;

  .popover-body {
    padding: 0;
  }
}
</style>
